import { queryOptions, useQuery } from "@tanstack/react-query";
import { listPrivateCategories } from "#/server/functions/privateProducts";

export const privateCategoriesQuery = queryOptions({
  queryKey: ["storefront", "private-categories"] as const,
  queryFn: () => listPrivateCategories(),
  staleTime: 5 * 60_000,
});

export function useExclusiveSlugs(): Set<string> {
  const { data } = useQuery(privateCategoriesQuery);
  return new Set(data?.map((c) => c.slug) ?? []);
}

export const PRIVATE_GRADIENT_TEXT =
  "bg-gradient-to-r from-lp-green-dk via-lp-yellow to-lp-green-mid bg-clip-text text-transparent";
export const PRIVATE_GRADIENT_BG =
  "bg-gradient-to-r from-lp-green-dk via-lp-yellow to-lp-green-mid text-white border-0";
export const PRIVATE_ICON_COLOR = "text-lp-yellow";
